var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"box",style:({ display: _vm.direction === 'X' ? 'table' : '' })},[_vm._t("default"),(_vm.num > _vm.limit)?_vm._t("default"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }